import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center" data-testid="auth-loading">
        <span className="font-serif text-2xl text-brown/40 italic">VLP Dolap</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/hesap" replace />;
  return children;
};

export default ProtectedRoute;
